// S6.5 follow-up D15 (shipped in S7) — sticky banner that signals an agent
// is in Plan mode (research-only, no file changes).
//
// Source of truth: `agent.permissionMode === 'plan'`. The Mode chip on the
// composer / ChatInput is the only writer for MVP. Mid-session
// EnterPlanMode/ExitPlanMode tool_use events (which Claude can fire on its
// own) are not handled here — the agent.permissionMode flag drives the
// banner. If we need finer mid-session granularity later, add it as a
// derived selector over recent tool_use events.
//
// Founder-first §5: plain English, no code-shaped detail. Single line,
// brand color. Implementation note: placed OUTSIDE MessageList (sibling
// of ChatHeader, above the scroll container). The flex column in ChatView
// keeps it pinned to the top of the chat surface — the message list
// scrolls below it — without needing `position: sticky`. Spec D15 said
// "sticky like D38"; this is the same visual outcome with less DOM
// coupling. No interaction with the header offset CSS var.

import type { Agent } from '../types';
import { useTranslation } from '../i18n';

export interface PlanModeBannerProps {
  agent: Agent;
}

export function PlanModeBanner({ agent }: PlanModeBannerProps) {
  const { t } = useTranslation();
  if (agent.permissionMode !== 'plan') return null;

  return (
    <div
      data-testid="plan-mode-banner"
      role="status"
      aria-live="polite"
      className="
        flex items-center justify-center gap-2
        px-4 py-2
        text-caption font-medium
        text-status-warning
        bg-status-warning/10 border-b border-status-warning/40
      "
    >
      <span>{t('planMode.banner')}</span>
    </div>
  );
}
